<div fxLayout="row" fxLayoutAlign="start space-between">
    <div *ngIf="hasFeatureAction">
        <metadata-action removeTabFocus="true" [action]="row.FeatureAction" [model]="model" [dense]="true" [formData]="getDataController(row.FeatureAction, model.$$TypeName)" [doFetch]="true" [fetchEntity]="bindFetchRowModel" [enableShortcut]="false"></metadata-action>
    </div>
    <forge-icon-button tabindex="-1" dense class="tt-margin--left" (contextmenu)="onContextMenu($event, row, true)" (mouseup)="middleClick($event, row, true)" *ngIf="canView" (click)="edit(row, true, $event)" telemetry="Submission-View">
        <forge-tooltip placement="bottom">View</forge-tooltip>
        <forge-icon name="visibility"></forge-icon>
    </forge-icon-button>

    <forge-icon-button tabindex="-1" dense class="tt-margin--left" (contextmenu)="onContextMenu($event, row, false)" (mouseup)="middleClick($event, row, false)" *ngIf="canEdit" (click)="edit(row, false, $event)" telemetry="Submission-Edit">
        <forge-tooltip placement="bottom">Edit</forge-tooltip>
        <forge-icon name="edit"></forge-icon>
    </forge-icon-button>

    <forge-icon-button tabindex="-1" dense class="tt-margin--left" *ngIf="canDelete" (click)="delete(row)" telemetry="Submission-Delete">
        <forge-tooltip placement="bottom">Delete</forge-tooltip>
        <forge-icon name="delete"></forge-icon>
    </forge-icon-button>

    <ng-container *ngIf="primaryActions">
        <div *ngFor="let action of primaryActions" class="tt-margin--left">
            <metadata-action [removeTabFocus]="true" [action]="action" [model]="model" [dense]="true"
                             [formData]="getDataController(action, model.$$TypeName)" [doFetch]="true"
                             [fetchEntity]="bindFetchRowModel" [enableShortcut]="false" (executed)="onActionExecuted()">
            </metadata-action>
        </div>
    </ng-container>
    <div *ngIf="hasOverflowActions" fxLayout="row" class="tt-margin--left">
        <forge-icon-button tabindex="-1" dense (click)="overflowMenu($event)">
            <forge-icon name="more_vert"></forge-icon>
        </forge-icon-button>
    </div>
</div>

<forge-popover #overFlowMenu placement="bottom-end">
    <forge-list dense="true">
        <forge-list-item *ngFor="let action of overflowActions">
            <button type="button" (click)="performAction(action, $event)" [disabled]="action.Disabled" style="color: var(--forge-theme-text-high);">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    {{actionLabel(action.Label)}}
                </div>
            </button>
        </forge-list-item>
    </forge-list>
</forge-popover>
